import {gql} from "@irati/utils/gql"

const companyNewsTileFragment = gql`
  fragment CompanyNewsTileFragment on CompanyNewsTile {
    uuid
    config {
      backgroundColor
      columnWidth
      imageUrl
      message
      templateIcon
      templateText
      type
      url
      videoUrl
      fileId
    }
    xpos
    ypos
  }
`

export default companyNewsTileFragment
